import firebase from 'firebase/compat/app';
import 'firebase/compat/auth';
import 'firebase/compat/firestore';

const firebaseConfig = {
    apiKey: "AIzaSyBByw87Jdry5pxQiO-hVlif5kfctffkXAw",
    authDomain: "portfolio-fc6e8.firebaseapp.com",
    projectId: "portfolio-fc6e8",
    storageBucket: "portfolio-fc6e8.appspot.com",
    messagingSenderId: "478217135987",
    appId: "1:478217135987:web:e27b53c1fdb2728af04706",
    measurementId: "G-689VS6MZ6J"
  };

  const firebaseApp = firebase.initializeApp(firebaseConfig);
// db will allow access to database from any file
const db=firebaseApp.firestore();

export default db;